import React from 'react';

function PublicReport() {
  return (
    <div style={{ backgroundColor: '#e6f3ff', minHeight: '100vh', width: '100%', margin: 0, padding: 0 }}>
      <h1>Public Report</h1>
    </div>
  );
}

export default PublicReport;

